import React from 'react';
import { makeStyles } from 'styles/util';
import strings from 'localization/strings';
import { useScrollToTop } from 'helpers/BrowserHelper';

import Container from 'common/Container';
import PageTitle from 'common/PageTitle';
import MarginBox from 'common/MarginBox';
import Typography from '@material-ui/core/Typography';
import FaqSection from 'components/faq/FaqSection';
import QuestionsAndAnswersImage from 'assets/images/q_and_a.jpg';
import ContactUsSection from './ContactUsSection';

const useStyles = makeStyles(({ theme }) => ({
    pageTitle: {
        marginBottom: theme.spacing(2)
    },
    questionsImageHero: {
        objectFit: 'cover',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            height: '200px'
        },
        height: '400px',
        borderRadius: '4px'
    }
}));

const ContactUsPage = () => {
    const classes = useStyles();

    useScrollToTop();

    return (
        <Container withPageMargins>
            <PageTitle>{strings.contactUs}</PageTitle>
            <MarginBox bottom={4}>
                <Typography variant="h1" className={classes.pageTitle}>{strings.contactUs}</Typography>
            </MarginBox>
            <MarginBox bottom={4}>
                <Typography variant="body1" className={classes.introDescription}>{strings.contactUsIntroduction}</Typography>
            </MarginBox>
            <MarginBox bottom={4}>
                <Typography variant="h3" gutterBottom>{strings.faqHeading}</Typography>
                <Typography variant="body1">{strings.faqBody}</Typography>
                <FaqSection/>
            </MarginBox>
            <MarginBox bottom={2}>
                <Typography variant="h3" className={classes.caption}>{strings.contactStorage}</Typography>
            </MarginBox>
            <MarginBox bottom={4}>
                <img className={classes.questionsImageHero} src={QuestionsAndAnswersImage} alt={strings.contactUs}/>
            </MarginBox>
            <div id="contact-details">
                <ContactUsSection/>
            </div>
        </Container>
    );
};

export default ContactUsPage;
